import type { SupportedLocale } from './numberFormat';

/**
 * Maps the app's i18n language keys (as stored in Redux) to valid BCP 47 locale
 * codes suitable for Intl.NumberFormat.
 *
 * The app's language keys ('mx', 'vl', etc.) are not valid BCP 47 tags, so they
 * cannot be passed directly to Intl APIs. Use this function to convert them before
 * passing the locale to InputNumeric or formatNumber.
 *
 * @example
 * const language = useSelector(coreEntities.i18n.selectors.getLanguage);
 * const locale = mapLanguageToLocale(language);
 * // <InputNumeric locale={locale} ... />
 */
export function mapLanguageToLocale(language: string | null | undefined): SupportedLocale {
  switch (language) {
    case 'mx':  return 'es-MX';
    case 'vl':  return 'ca-ES';
    case 'es':  return 'es-ES';
    case 'en':  return 'en-US';
    case 'pt':  return 'pt-BR';
    case 'ca':  return 'ca-ES';
    case 'eu':  return 'eu-ES';
    case 'gl':  return 'gl-ES';
    default:    return 'es-ES';
  }
}
